import { ComponentProps } from 'react';
import AppStoreSVG from '@/assets/images/app-store.svg';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Layout>;

export const AppStore = ({ href, ...props }: Props) => {
    const url = href?.trim();
    if (!url || url === '#') return null;

    return (
        <Layout element="a" href={url} target="_blank" rel="noopener noreferrer" {...props}>
            <AppStoreSVG width={120} height={40} />
        </Layout>
    );
};
